module.exports = __webpack_public_path__ + "static/media/lightbulb-exclamation.3c20b347.svg";